<script setup>
import { onBeforeMount, computed, ref } from "vue";
import { useApiService } from "./utils/useApiService";
const { fetchWrapperForGet } = useApiService();
const getUserContext = async () => {
  const token = await fetchWrapperForGet("api/antiforgerytoken");
  const csrfToken = token.antiForgeryToken;

  document.cookie = `X-CSRF-TOKEN=${csrfToken}; path=/; secure; SameSite=Lax`;
  document.cookie = `CSRF-TOKEN=${csrfToken}; path=/; secure; SameSite=Lax`;
};
const getSitekey = async () => {
  const res = await fetch('/api/api/antiforgerytoken/sitekey');
  // const res = await fetch('api/antiforgerytoken/sitekey');
  const data = await res.json();
  localStorage.setItem('sitekey', data.sitekey)
}
onBeforeMount(async () => {
  getUserContext();
  getSitekey();
});
</script>

<template>
  <router-view />
</template>

<style></style>
